import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';
import { nullableDate } from '../utils/format.ts';

export class Bookmark extends Model<Schemas['bookmarks'], Models> {
    get createdAtDate() {
        return nullableDate(this.createdAt);
    }

    get updatedAtDate() {
        return nullableDate(this.updatedAt);
    }
}
